// Rough first-pass title suggestion from an uploaded filename — title-cased,
// noise words stripped, a trailing year pulled to the end. This is a cheap
// heuristic only; once document intelligence extraction finishes, the
// carrier/line/date it yields is the better source (see the "Use AI title"
// action on DocumentIntelligenceChip).
const NOISE_WORDS = new Set([
  'renewal', 'final', 'copy', 'draft', 'revised', 'updated', 'new',
  'fw', 'fwd', 're', 'v1', 'v2', 'v3', 'signed', 'scan', 'scanned',
]);

export function splitFileName(name: string): { base: string; ext: string } {
  const lastDot = name.lastIndexOf('.');
  if (lastDot <= 0) return { base: name, ext: '' };
  return { base: name.slice(0, lastDot), ext: name.slice(lastDot) };
}

export function suggestDocumentTitle(filename: string): string {
  const { base } = splitFileName(filename);

  const yearMatch = base.match(/\b(19|20)\d{2}\b/);
  const year = yearMatch ? yearMatch[0] : null;

  let cleaned = base.replace(year || '', '').replace(/[_\-.]+/g, ' ');

  const words = cleaned
    .split(/\s+/)
    .filter(Boolean)
    .filter((w) => !NOISE_WORDS.has(w.toLowerCase()));

  const titleCased = words
    .map((w) => (w === w.toUpperCase() && w.length <= 4 ? w : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()))
    .join(' ')
    .trim();

  if (!titleCased) return year ? year : base;
  return year ? `${titleCased} ${year}` : titleCased;
}
